<template>
    <div>
        <h3 class="text-center mt-4 mb-3">{{jsonObjectHistory.histHeader}}</h3>
        
        <img class="float-left" style="margin-right: 20px" src="http://horsesport.ge/images/002.jpg" alt="History horse sculpture">
        
        <p v-html="jsonObjectHistory.histPar1"></p>
        <p v-html="jsonObjectHistory.histPar2"></p>
        <p v-html="jsonObjectHistory.histPar3"></p>

    </div>
</template>

<script>
    import jsonObjectHistory from './History.json';
export default {

    data(){
        return {
            jsonObjectHistory,
        }
    }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/EN-vers/menu/History.vue